function removeReactNativeWebAnimatedPlugin(opts) {
  var filter = (opts === null || opts === void 0 ? void 0 : opts.panResponder) ? /(react-native\/Animated\/Animated|PlatformPressable|PanResponder|ResponderSystem)/ : /(react-native\/Animated\/Animated|PlatformPressable)/;
  var optimizeDeps = {
    rolldownOptions: {
      plugins: [
        {
          name: "remove-react-native-web-animated",
          resolveId(source) {
            if (filter.test(source)) {
              return `\0proxy-wormify:${source}`;
            }
          },
          load(id) {
            if (id.startsWith("\0proxy-wormify:")) {
              return `export * from "@tamagui/proxy-worm";`;
            }
          }
        }
      ]
    }
  };
  return {
    name: "remove-react-native-web-animated",
    config() {
      return {
        optimizeDeps
      };
    }
  };
}
export {
  removeReactNativeWebAnimatedPlugin
};
//# sourceMappingURL=removeReactNativeWebAnimatedPlugin.js.map
